import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-info-modal',
    templateUrl: './info-modal.component.html',
    styleUrls: ['./info-modal.component.scss'],
    standalone: true,
    imports: [MatButton, TranslateModule]
})
export class InfoModalComponent {

  openModal() {
    const element = document.getElementById('modal-information');
    element?.classList.add('open');
  }

  hideModal() {
    const element = document.getElementById('modal-information');
    element?.classList.remove('open');
    document.body.style.overflow = 'auto';
  }

}
